import { render, staticRenderFns } from "./ryzz.vue?vue&type=template&id=30cad28a&scoped=true"
import script from "./ryzz.vue?vue&type=script&lang=js"
export * from "./ryzz.vue?vue&type=script&lang=js"
import style0 from "./ryzz.vue?vue&type=style&index=0&id=30cad28a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cad28a",
  null
  
)

export default component.exports